// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__1teAW","actions":"GroupTable_actions__3EJDt","deleteModalFooter":"GroupTable_deleteModalFooter__3Lnlg"};